import React from "react";
import logo from "../assets/logo_nobg.png";
import { projects } from "../data/projects";

const STATUS = {
  "Live":        { label: "Live",         color: "#4ade80", bg: "rgba(74,222,128,0.1)" },
  "In Progress": { label: "In Progress",  color: "#C7F94B", bg: "rgba(199,249,75,0.12)" },
  "Coming Soon": { label: "Coming Soon",  color: "#9AA3AF", bg: "rgba(138,128,120,0.12)" },
};

export default function Build() {
  const featured = projects.filter((p) => p.featured);
  const others = projects.filter((p) => !p.featured);

  return (
    <div className="bd">
      <style>{CSS}</style>

      <nav className="bd-nav">
        <div className="bd-nav-inner">
          <a href="https://shashankupadhyaya.com" className="bd-logo">
            <img src={logo} alt="S/U" className="site-logo-img" />
            <span className="bd-logo-label">Build</span>
          </a>
          <a href="https://github.com/shaxhxnk" target="_blank" rel="noreferrer" className="bd-btn bd-btn--outline">
            GitHub ↗
          </a>
          <a href="https://shashankupadhyaya.com" className="bd-nav-back">← Portfolio</a>
        </div>
      </nav>

      <div className="bd-page">

        <div className="bd-header">
          <div className="bd-header-inner">
            <span className="bd-chip">Products &amp; Projects</span>
            <h1 className="bd-h1">What I'm Building</h1>
            <p className="bd-lead">AI tools, products, and experiments — all built in public.</p>
          </div>
        </div>

        <div className="bd-container">

          {projects.length === 0 ? (
            <div className="bd-state">
              <span className="bd-state-icon">🚧</span>
              <p>Projects coming soon.</p>
            </div>
          ) : (
            <>
              {featured.length > 0 && (
                <div className="bd-section">
                  <h2 className="bd-section-title">Featured Projects</h2>
                  <div className="bd-featured-grid">
                    {featured.map((p) => <ProjectCard key={p.id} project={p} large />)}
                  </div>
                </div>
              )}

              {others.length > 0 && (
                <div className="bd-section">
                  <h2 className="bd-section-title">More Projects</h2>
                  <div className="bd-grid">
                    {others.map((p) => <ProjectCard key={p.id} project={p} />)}
                  </div>
                </div>
              )}
            </>
          )}

        </div>

        <footer className="bd-footer">
          <div className="bd-container">
            <span>© 2026 Shashank Upadhyaya</span>
            <a href="https://shashankupadhyaya.com">shashankupadhyaya.com ↗</a>
          </div>
        </footer>
      </div>
    </div>
  );
}

function ProjectCard({ project, large }) {
  const s = STATUS[project.status] || STATUS["Coming Soon"];
  return (
    <div className={`bd-card${large ? " bd-card--large" : ""}`}>
      <div className="bd-card-top">
        <div className="bd-card-name-row">
          <h2 className="bd-card-name">{project.name}</h2>
          {project.status && (
            <span className="bd-status" style={{ color: s.color, background: s.bg }}>
              {s.label}
            </span>
          )}
        </div>
        <p className="bd-card-desc">{project.description}</p>
      </div>
      {project.stack?.length > 0 && (
        <div className="bd-stack">
          {project.stack.map((t) => <span key={t} className="bd-chip-tag">{t}</span>)}
        </div>
      )}
      {(project.liveUrl || project.githubUrl) && (
        <div className="bd-card-actions">
          {project.liveUrl && (
            <a className="bd-btn bd-btn--gold" href={project.liveUrl} target="_blank" rel="noreferrer">
              View Live →
            </a>
          )}
          {project.githubUrl && (
            <a className="bd-btn bd-btn--outline" href={project.githubUrl} target="_blank" rel="noreferrer">
              GitHub ↗
            </a>
          )}
        </div>
      )}
    </div>
  );
}

const CSS = `
  .bd {
    --bg: #0A0B0D;
    --card: #0E1116;
    --border: rgba(255,255,255,0.08);
    --text: #EDEFF2;
    --muted: #9AA3AF;
    --gold: #C7F94B;
    --gold-dim: rgba(199,249,75,0.12);
    --nav-h: 64px;
    --radius: 8px;
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    font-size: 15px;
    -webkit-font-smoothing: antialiased;
  }
  .bd *, .bd *::before, .bd *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .bd a { color: inherit; text-decoration: none; }
  .bd button { cursor: pointer; font-family: inherit; }

  /* Nav */
  .bd-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 50;
    height: var(--nav-h); background: rgba(10,11,13,0.95);
    backdrop-filter: blur(20px); border-bottom: 1px solid var(--border);
  }
  .bd-nav-inner {
    max-width: 1100px; margin: 0 auto; padding: 0 28px;
    height: 100%; display: flex; align-items: center; gap: 20px;
  }
  .bd-logo { display: flex; align-items: center; gap: 10px; }
  .site-logo-img { height: 56px; width: auto; display: block; object-fit: contain; }
  .bd-logo-label { font-size: 13px; color: var(--muted); padding-left: 10px; border-left: 1px solid var(--border); }
  .bd-nav-back { font-size: 13px; color: var(--muted); margin-left: auto; transition: color 0.15s; }
  .bd-nav-back:hover { color: var(--gold); }

  /* Page */
  .bd-page { padding-top: var(--nav-h); }

  /* Header */
  .bd-header { border-bottom: 1px solid var(--border); padding: 64px 0 48px; }
  .bd-header-inner { max-width: 1100px; margin: 0 auto; padding: 0 28px; }
  .bd-chip {
    display: inline-block; font-size: 11px; font-weight: 600; letter-spacing: 0.08em;
    text-transform: uppercase; color: var(--gold);
    background: var(--gold-dim); border: 1px solid rgba(199,249,75,0.25);
    padding: 4px 10px; border-radius: 4px; margin-bottom: 20px;
  }
  .bd-h1 {
    font-family: 'Archivo', sans-serif; font-weight: 900;
    font-size: clamp(32px, 5vw, 52px); letter-spacing: -0.03em; line-height: 1.05; margin-bottom: 14px;
  }
  .bd-lead { font-size: 16px; color: var(--muted); line-height: 1.7; }

  /* Container */
  .bd-container { max-width: 1100px; margin: 0 auto; padding: 0 28px; }

  /* Section */
  .bd-section { padding: 48px 0; border-bottom: 1px solid var(--border); }
  .bd-section-title {
    font-family: 'Archivo', sans-serif; font-weight: 700;
    font-size: 13px; letter-spacing: 0.08em; text-transform: uppercase;
    color: var(--muted); margin-bottom: 24px;
  }

  /* Grids */
  .bd-featured-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
  .bd-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }

  /* Cards */
  .bd-card {
    background: var(--card); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 24px;
    display: flex; flex-direction: column; gap: 16px;
    transition: border-color 0.2s, transform 0.2s;
  }
  .bd-card:hover { border-color: rgba(199,249,75,0.4); transform: translateY(-2px); }
  .bd-card--large { padding: 28px; }
  .bd-card-top { display: flex; flex-direction: column; gap: 10px; }
  .bd-card-name-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
  .bd-card-name {
    font-family: 'Archivo', sans-serif; font-weight: 700;
    font-size: 18px; letter-spacing: -0.01em; min-width: 0;
  }
  .bd-card--large .bd-card-name { font-size: 22px; }
  .bd-status {
    font-size: 11px; font-weight: 600; letter-spacing: 0.04em;
    padding: 4px 10px; border-radius: 20px; white-space: nowrap; flex-shrink: 0;
  }
  .bd-card-desc { font-size: 14px; color: var(--muted); line-height: 1.65; }

  /* Stack */
  .bd-stack { display: flex; flex-wrap: wrap; gap: 6px; }
  .bd-chip-tag {
    font-size: 11px; color: var(--muted);
    background: rgba(255,255,255,0.05); border: 1px solid var(--border);
    padding: 3px 10px; border-radius: 20px;
  }

  /* Actions */
  .bd-card-actions { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 4px; }
  .bd-btn {
    display: inline-flex; align-items: center; font-size: 14px; font-weight: 600;
    padding: 9px 18px; border-radius: 6px; border: none;
    cursor: pointer; transition: all 0.15s;
  }
  .bd-btn--gold { background: var(--gold); color: #000; }
  .bd-btn--gold:hover { opacity: 0.88; }
  .bd-btn--outline { background: transparent; color: var(--text); border: 1px solid var(--border); }
  .bd-btn--outline:hover { border-color: var(--gold); color: var(--gold); }

  /* State */
  .bd-state {
    text-align: center; padding: 80px 0;
    display: flex; flex-direction: column; align-items: center; gap: 14px;
    font-size: 14px; color: var(--muted);
  }
  .bd-state-icon { font-size: 32px; }

  /* Footer */
  .bd-footer { margin-top: 80px; border-top: 1px solid var(--border); padding: 28px 0; }
  .bd-footer .bd-container { display: flex; align-items: center; justify-content: space-between; font-size: 13px; color: var(--muted); }
  .bd-footer a { transition: color 0.15s; }
  .bd-footer a:hover { color: var(--gold); }

  /* Responsive */
  @media (max-width: 900px) {
    .bd-featured-grid { grid-template-columns: 1fr; }
    .bd-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 600px) {
    .bd-grid { grid-template-columns: 1fr; }
    .bd-h1 { font-size: 28px; }
    .bd-nav-back { display: none; }
    .bd-nav-inner > .bd-btn--outline { display: none; }
    .bd-logo-label { display: none; }
    .site-logo-img { height: 40px; }
    .bd-header { padding: 40px 0 28px; }
    .bd-card--large { padding: 20px; }
    .bd-card { padding: 16px; }
    .bd-container, .bd-header-inner { padding-left: 16px; padding-right: 16px; }
  }
  @media (max-width: 480px) {
    .bd-footer .bd-container { flex-direction: column; gap: 8px; text-align: center; }
  }
`;
